module.exports = __webpack_public_path__ + "img/21_6.6468f5f8.png";